// This file is called site-constants and not just constants to avoid type clashes with Node

export const MOBILE_UPPER_THRESHOLD = 576;
export const TABLET_LOWER_THRESHOLD = MOBILE_UPPER_THRESHOLD + 1;
export const TABLET_UPPER_THRESHOLD = 1199;
export const DESKTOP_LOWER_THRESHOLD = TABLET_UPPER_THRESHOLD + 1;
